import {connect} from "react-redux";
import WarehousePanelSet from "./WarehousePanelSet";
import * as InventoryApiActions from "../../actions/InventoryApiActions";
import * as ShippingApiActions from "../../actions/ShippingApiActions";
import * as SelectionActions from "../../actions/SelectionActions";
import * as ViewActions from "../../actions/ViewActions";
import {getSelection} from "../../reducers/selectionReducer";
import {getWarehouseWithId} from "../../reducers/inventoryReducer";

function mapStateToProps(state) {
  const context = "warehouses";
  const selection = getSelection(state.get("selection"), context);  
  return {
    context: context,
    selectedWarehouse: getWarehouseWithId(state.get("inventory"), selection),
    selection: selection,
    hasSelection: selection !== ""
  }
}

export default connect(mapStateToProps, {...InventoryApiActions, ...ShippingApiActions, ...SelectionActions, ...ViewActions})(WarehousePanelSet);